// Electricity
export enum PrmPoweredStatus {
    POWERED = "ALIM",
    CUT_OFF = "COUP",
    LIMITED = "LIMI",
    NOT_POWERED = "NALI",
    NOT_CONNECTED = "NRAC",
}

// Gas
export enum PcePoweredStatus {
    CUT = "coupe",
    NOT_CUT = "non_coupe",
    METER_REMOVED = "compteur_depose",
}
